import { RpcError } from "grpc-web";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import {
  Event,
  GetUserEventsRequest,
  GetUserEventsResponse,
  UpdateUserEventRequest,
  UpdateUserEventResponse,
} from "../proto/api_pb";
import { backOff } from "exponential-backoff";
import { Dispatch, SetStateAction } from "react";

export const getAllEventsOfUser: (
  token: string,
  userId: string,
  setAllEvents: Dispatch<SetStateAction<Event[] | undefined>>
) => Promise<GetUserEventsResponse | RpcError> = async (
  token: string,
  userId: string,
  setAllEvents: Dispatch<SetStateAction<Event[] | undefined>>
): Promise<GetUserEventsResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new GetUserEventsRequest();
  request.setUserId(userId);
  const metadata = {
    Authorization: token,
    "Access-Control-Allow-Origin": "*",
  };

  try {
    const response = await backOff(
      () =>
        new Promise<GetUserEventsResponse | RpcError>((resolve, reject) => {
          ommuseClient.getUserEvents(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );

    if (response instanceof GetUserEventsResponse) {
      setAllEvents(response.getEventsList());
    }
    return response;
  } catch (error) {
    console.error("Error fetching user events:", error);
    throw error;
  }
};

export const handleUpdate: (
  id: string,
  userId: string,
  token: string
) => Promise<RpcError | UpdateUserEventResponse> = async (
  id: string,
  userId: string,
  token: string
) => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new UpdateUserEventRequest();
  request.setId(id);
  request.setUserId(userId);
  const metadata = {
    Authorization: token,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<UpdateUserEventResponse | RpcError>((resolve, reject) => {
        ommuseClient.updateUserEvent(
          request,
          metadata,
          function (err, response) {
            if (err) {
              reject(err);
            } else {
              resolve(response);
            }
          }
        );
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};
